<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="bg-red">
        <v-layout justify-center align-center>
          <v-img max-width="180" :src="image"></v-img>
        </v-layout>
      </v-card-title>
      <h2 class="text-center mt-5 black-font">
        <strong class="black-font">Comunicado</strong>
      </h2>
      <v-card-text class="font-weight-black text-center pa-10 black-font">
        <h2 class="font-weight-regular black-font">{{textmodal}}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-layout justify-center align-center>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="primary_dark" class="boldFont" text @click="dialog = false">Entendido</v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.bg-red {
  background-color: #8a172b !important;
}
.boldFont {
  font-weight: bolder !important;
}
.black-font {
  color: black !important;
}
</style>
<script>
export default {
  props: ["image"],
  data() {
    return {
      dialog: true,
      textmodal:
        "A través del presente hacemos del conocimiento de todos nuestros clientes, seguidores y público en general que Capitalica, es una empresa socialmente responsable de sus clientes, por lo que nuestros tramites son realizados de manera transparente y personalizados bajo nuestro proceso de Calidad: en los cuales, No solicitamos dinero por adelanto como anticipo para elaboración de solicitudes y/o autorización de créditos"
    };
  }
};
</script>